import {Button, Card, Stack, Typography} from "@mui/material";
import React from "react";
import {Expense, Pricing} from "../../../firebase/index.js";
import {industryColour} from "../../../reusables/js/APXTheme.js";
import {createExpensePlots, createPricingPlots} from "./IndustryAnalyticsGraphs.js";


export default function AnalyticsLayout({pps, exps}: { pps: Pricing[], exps: Expense[] }) {
	  
	  const pricings: Pricing[] = /* dummyPricings */ pps;
	  const expenses: Expense[] = exps;
	  
	  const pRef = React.useRef(null);
	  const [reload, setReload] = React.useState(0);
	  
	  React.useEffect(() => {
			 
			 const pricingPlots = createPricingPlots(pricings || []);
			 const expensePlots = createExpensePlots(expenses || []);
			 
			 const allPlots = [...pricingPlots, ...expensePlots];
			 
			 pRef.current.append(...allPlots);
			 
			 return () => allPlots.forEach(p => p.remove());
			 
	  }, [pricings, expenses, reload]);
	  
	  const [show, setShow] = React.useState(true);
	  React.useEffect(() => {
			 setTimeout(() => setShow(false), 5000);
	  }, []);
	  
	  const msg = "If you face issue with viewing the graphs in portrait-mode, please switch to landscape-mode and reload.";
	  
	  return (
				 <>
						<Card key={reload} variant={"outlined"} sx={{p: 4, my: 2, borderColor: industryColour}}>
							  <Stack ref={pRef} spacing={6} alignItems={"stretch"} justifyContent={"center"}/>
							  <Stack p={0} mt={4} justifyContent={"center"} alignItems={"center"}>
									 {show && <Typography align={"center"} fontSize={10}>{msg}</Typography>}
									 <Button variant={"text"} size={"small"} sx={{color: industryColour, fontSize: 10}} onClick={() => setReload(prevState => prevState + 1)}>Reload</Button>
							  </Stack>
						</Card>
				 </>
	  );
}
